<template>
  <v-card>
    <v-card-text>
      <storage-usage />
    </v-card-text>
    <v-card-title>
      <v-btn
        color="primary"
        @click="$inertia.visit(route('media.create'), { preserveState: true })"
      >
        {{ $t('Upload media') }}
      </v-btn>
      <v-spacer />
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('Search')"
        single-line
        hide-details
      />
    </v-card-title>
    <media-table
      :uploads="uploads"
      :search="search"
    />
  </v-card>
</template>

<script>
import i18n from '@/plugins/vue-i18n';
import MediaTable from './MediaTable';
import Layout from '@/components/shared/TheLayout';

export default {
  components: {
    MediaTable,
  },

  layout: (h, page) => h(Layout, {
    props: {
      pageTitle: i18n.t('Media library')
    }
  }, [page]),

  props: {
    uploads: {
      type: Array,
      required: true
    },
    upload: {
      type: Object,
      required: false,
      default: null
    }
  },

  data() {
    return {
      search: ''
    }
  }
}
</script>